import Select, { components } from 'react-select';
import { ArrowBottom, CheckMark, CloseIcon } from '../../assets/icons/Icons';
import '../../assets/scss/components/react-select.scss'
const CustomSelect = ({ styles: stylesOverride, ...props }) => {

    const DropdownIndicator = (props) => {
        const { selectProps } = props;
        const rotation = selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)';
        return (
            components.DropdownIndicator && (
                <components.DropdownIndicator {...props}>
                    <ArrowBottom style={{ transform: rotation, transition: 'transform 0.3s ease' }} />
                </components.DropdownIndicator>
            )
        );
    };

    const CustomOption = (props) => {
        return (
            <components.Option {...props}>
                {props.data.label}
            </components.Option>
        );
    };

    const CustomMultiValueRemove = (props) => {
        return (
            <components.MultiValueRemove {...props}>
                <CloseIcon style={{ width: '10px', height: '10px'}}/>
            </components.MultiValueRemove>
        );
    };

    const ClearIndicator = (props) => {
        return (
            <components.ClearIndicator {...props}>
                <CloseIcon style={{ width: '10px', height: '10px'}}/>
            </components.ClearIndicator>
        );
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: 'var(--form-input-height)',
            borderRadius: 'var(--form-input-border-radius)',
            borderColor: 'var(--form-input-border-color)',
            boxShadow: 'none',
            outline: 'none',
            '&:hover': {
                borderColor: state.isFocused ? 'var(--color-primary)' : provided['&:hover'].borderColor
            },
            cursor: 'pointer',

        }),
        valueContainer: (provided, state) => ({
            ...provided,
            padding: state.selectProps.isMulti && state.hasValue ? '5px' : '0 20px',
            flexWrap: state.selectProps.isMulti ? 'wrap' : 'nowrap'
        }),
        placeholder: (provided, state) => ({
            ...provided,
            height: 'var(--form-input-height)',
            display: 'flex',
            alignItems: 'center',
            color: 'var(--form-input-placeholder-color)',
            fontSize: 'var(--form-input-placeholder-font-size)',
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            padding: 0,
            marginRight: '20px',
            color: 'var(--form-input-color)'
        }),
        indicatorSeparator: (provided, state) => ({
            display: 'none'
        }),
        input: (provided, state) => ({
            ...provided,
            margin: '0',
            height: state.selectProps.isMulti && state.hasValue ? '20px' : '',
            padding: 0,
        }),
        option: (provided, state) => ({
            ...provided,
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: 'none',
            color: state.isSelected ? 'var(--color-primary)' : 'var(--form-input-color)',
            cursor: 'pointer',
            '&:hover': {
                color: 'var(--color-primary)',
            },
        }),
        multiValue: (provided, state) => ({
            ...provided,
            backgroundColor: 'var(--multi-select-background-color)',
            padding: '4px 6px'
        }),
        multiValueLabel: (provided, state) => ({
            ...provided,
            color: 'var(--multi-select-label-color)',
            fontSize: '14px',
            lineHeight: '1'
        }),
        multiValueRemove: (provided, state) => ({
            ...provided,
            color: 'var(--multi-select-remove-color)',
            ':hover': {
                backgroundColor: 'var(--multi-select-remove-hover-background-color)',
                color: 'var(--multi-select-remove-hover-color)',
            },
        }),
    };

    return (
        <Select className="react-select"
            hideSelectedOptions={props.isMulti}
            components={{
                DropdownIndicator,
                Option: CustomOption,
                MultiValueRemove: CustomMultiValueRemove,
                ClearIndicator
            }}
            styles={{ ...customStyles, ...stylesOverride }}
            size={props?.size || 'default'}
            {...props}
        />
    );
};

export default CustomSelect;
